import { PropsWithChildren, useMemo } from 'react'

import { useContact } from '../../hooks/useContact'

import { ContactContext } from './ContactContext'

export function ContactProvider({ children }: PropsWithChildren) {
  const { requirement, setRequirement, language, setLanguage, resetContact } =
    useContact()
  const value = useMemo(
    () => ({
      requirement,
      setRequirement,
      language,
      setLanguage,
      resetContact,
    }),
    [language, requirement, resetContact, setLanguage, setRequirement]
  )

  return (
    <ContactContext.Provider value={value}>{children}</ContactContext.Provider>
  )
}
